<section class="auth-card" aria-labelledby="auth-pvz-title">
  <h1 class="auth-card__title auth-card__title--left" id="auth-pvz-title">
    Вход на пункт выдачи
  </h1>

  <div class="auth-pvz-address-container">
    <div class="auth-pvz-address">{{ store.account().pvz }}</div>
    <div class="auth-pvz-address-separator">·</div>
    <div class="auth-pvz-date">{{ store.currDate() | date: 'dd MMMM yyyy' }}</div>
  </div>

  <pa-message
    *ngIf="store.pvzEmployeesLoaded() && store.accounts().length > 0"
    severity="info"
    icon="pi pi-info-circle"
    size="small"
  >
    Выберите профиль для входа.
    Если вас нет в списке, войдите как подменный сотрудник.
  </pa-message>

  <pa-message
    *ngIf="store.pvzEmployeesLoaded() && store.accounts().length === 0"
    severity="warn"
    icon="pi pi-exclamation-triangle"
    size="small"
  >
    Сотрудники для этого ПВЗ не найдены.
    При необходимости войдите как подменный сотрудник.
  </pa-message>

  <ul class="auth-account-list" role="list">
    <li *ngFor="let a of store.accounts(); index as i" class="auth-account-list__item">
      <button
        type="button"
        class="auth-account-card"
        [ngClass]="{ 'auth-account-card--odd': i % 2 !== 0 }"
        (click)="selectPvzAccount(a.id)"
      >
        <span class="auth-account-card__body">
          <span class="auth-account-card__name">{{ a.name }}</span>
          <span class="auth-account-card__meta">{{ a.role_name }}</span>
          <span *ngIf="a.shift_today" class="auth-account-card__shift">Смена сегодня</span>
        </span>
        <i class="pi pi-sign-in auth-account-card__icon" aria-hidden="true"></i>
      </button>
    </li>

    <li class="auth-account-list__item">
      <button type="button" class="auth-account-card" (click)="selectPvzAccount(0)">
        <span class="auth-account-card__body">
          <span class="auth-account-card__name">Подменный сотрудник</span>
          <span class="auth-account-card__meta">Если не нашли себя в списке</span>
        </span>
        <i class="pi pi-sign-in auth-account-card__icon" aria-hidden="true"></i>
      </button>
    </li>
  </ul>

  <app-support-link-v2 />
  <p class="auth-version mt-16">ver. {{ environment.appVer }}</p>
</section>
